import { Form, Spin } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import { FilterListGlobalBean, ItemResponseFilterListGlobalBeanObject } from 'common/api/api'
import { filterListGlobalApi } from 'common/api/entitiesApi'
import { AnchorsForm } from 'common/components/AnchorsForm'
import { ButtonsPanel } from 'common/components/ButtonsPanel'
import { FilterListModeSelector } from 'common/components/dictionary/FilterListModeSelector.tsx'
import { FormCard } from 'common/components/FormCard'
import { StatusSwitch } from 'common/components/StatusSwitch'
import { useAppContext } from 'common/context/AppContext'
import { CommonRoutes } from 'common/context/commonRoutes.ts'
import { queueListRepositionOnModifiedChange } from 'common/util/listNavigation.ts';
import { apiCall, FormMode, showError } from 'common/util/Util'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import FilterListGlobalCard from './FilterListGlobalCard'

export const FilterListGlobalForm = ({ mode, admin, agency }) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()
  const [entity, setEntity] = useState<FilterListGlobalBean>({ active: true } as FilterListGlobalBean)

  const navigateTo = useNavigate()
  const { id } = useParams<{ id?: string }>()
  const idNum = id ? parseInt(id) : 0

  const appContext = useAppContext()

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      const newEntity = { ...entity, ...values } as FilterListGlobalBean

      if (!newEntity.filterListId) {
        showError(appContext, 'Please select Filter List')
        return
      }

      const request =
        mode === FormMode.edit && id
          ? filterListGlobalApi.filterListGlobalUpdate(newEntity, idNum)
          : filterListGlobalApi.filterListGlobalCreate(newEntity)

      setLoading(true)
      request
        .then((response) => {
          queueListRepositionOnModifiedChange({
            appContext,
            routeKey: CommonRoutes.FILTER_LIST_GLOBAL,
            previousEntity: entity,
            responseEntity: response?.data,
            enabled: mode === FormMode.edit
          })

          navigateTo(CommonRoutes.FILTER_LIST_GLOBAL)
        })
        .catch((e) => {
          setLoading(false)
          showError(appContext, e)
        })
    })
  }

  const deleteRule = () => {
    apiCall(
      setLoading,
      appContext,
      () => filterListGlobalApi.filterListGlobalDelete(idNum),
      () => navigateTo(CommonRoutes.FILTER_LIST_GLOBAL),
    )
  }

  useEffect(() => {
    if (mode === 'edit') {
      apiCall(
        setLoading,
        appContext,
        () => filterListGlobalApi.filterListGlobal(idNum),
        (data: ItemResponseFilterListGlobalBeanObject) => {
          if (data && data.data) {
            setEntity(data.data)
            form.setFieldsValue(data.data)
          }
        },
      )
    } else {
      form.setFieldsValue(entity)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode, id])

  return (
    <Spin spinning={loading}>
      <AnchorsForm form={form} onFinish={handleSubmit}>
        <FormCard
          title="Filter List Global"
          extra={
            <StatusSwitch
              entity={entity}
              setEntity={setEntity}
              tooltip="Toggle to enable or disable the global filter list."
            />
          }
        >
          <FormItem
            required
            name="mode"
            label="Mode"
            tooltip={
              <>
                <div>Defines how the filter list is applied - whether it blocks or allows traffic based on the list rules.</div>
                <div style={{ marginTop: 8 }}>Black - Blocks traffic that matches the list criteria.</div>
                <div style={{ marginTop: 8 }}>White - Allows only traffic that matches the list criteria.</div>
              </>
            }
            rules={[{ required: true, message: 'Please select Mode' }]}
          >
            <FilterListModeSelector style={{ width: 200 }} />
          </FormItem>

          <FilterListGlobalCard entity={entity} setEntity={setEntity} admin={admin} agency={agency} />
        </FormCard>

        <ButtonsPanel
          onCancel={() => navigateTo(CommonRoutes.FILTER_LIST_GLOBAL)}
          showDelete={mode === FormMode.edit}
          onDelete={deleteRule}
        />
      </AnchorsForm>
    </Spin>
  )
}
